exports.f = {}.propertyIsEnumerable;


//////////////////
// WEBPACK FOOTER
// A:/Work/Siti/Volpe2/~/core-js/modules/_object-pie.js
// module id = ../../../../core-js/modules/_object-pie.js
// module chunks = 0